import React from "react";

const FilterDraw = () => (
  <svg
    width="100"
    height="63"
    viewBox="0 0 100 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M99.4196 0H0V18.3843H99.4196V0Z"
      transform="translate(.58)"
      fill="url(#paint0_linear)"
    />
    <path
      d="M98.1129 0H0V16.805H98.1129V0Z"
      transform="translate(1.16 .602)"
      fill="#fff"
    />
    <path
      d="M57.0342 0H0V10.0011H57.0342V0Z"
      transform="translate(7.187 4.032)"
      fill="#F5F5F5"
    />
    <path
      d="M9.09004 1.62216C8.39339 0.897152 7.50426 0.386065 6.52715 0.148958C5.55005 -0.0881494 4.52556 -0.0414246 3.57409 0.283642C2.62262 0.608709 1.78371 1.19861 1.15594 1.98402C0.528174 2.76943 0.137639 3.71771 0.0302289 4.71742C-0.0771817 5.71713 0.102997 6.72673 0.549591 7.62757C0.996186 8.52841 1.69064 9.28306 2.55134 9.80283C3.41203 10.3226 4.40321 10.5859 5.40839 10.5618C6.41356 10.5376 7.39096 10.2271 8.22573 9.66663L12.0433 13.6381C12.0667 13.6625 12.0947 13.6821 12.1256 13.6957C12.1566 13.7092 12.1899 13.7165 12.2237 13.7172C12.2575 13.7178 12.2911 13.7117 12.3226 13.6994C12.354 13.687 12.3827 13.6685 12.407 13.645L13.358 12.7328C13.3824 12.7094 13.402 12.6814 13.4155 12.6504C13.4291 12.6195 13.4364 12.5861 13.437 12.5523C13.4377 12.5185 13.4316 12.4849 13.4192 12.4535C13.4068 12.422 13.3884 12.3933 13.3648 12.369L9.54729 8.39753C10.2798 7.39465 10.6355 6.16571 10.5519 4.92662C10.4683 3.68752 9.95067 2.51752 9.09004 1.62216ZM7.90076 8.00756C7.36214 8.5253 6.68209 8.8717 5.94661 9.00297C5.21112 9.13424 4.45323 9.04447 3.76876 8.74503C3.08429 8.44558 2.50398 7.9499 2.10121 7.32066C1.69843 6.69142 1.49128 5.95688 1.50595 5.20992C1.52062 4.46295 1.75645 3.73711 2.18361 3.12417C2.61078 2.51123 3.2101 2.03872 3.9058 1.76637C4.6015 1.49403 5.36233 1.43409 6.0921 1.59413C6.82186 1.75417 7.48778 2.127 8.00567 2.66549C8.69853 3.38749 9.07662 4.35489 9.05695 5.35537C9.03728 6.35585 8.62147 7.30765 7.90076 8.00186V8.00756Z"
      transform="translate(77.257 3.053)"
      fill="url(#paint1_linear)"
    />
    <path
      d="M0.318987 6.95954e-08C-0.106326 6.95954e-08 -0.106326 0.660205 0.318987 0.660205C0.744301 0.660205 0.744301 6.95954e-08 0.318987 6.95954e-08Z"
      transform="translate(79.422 7.282)"
      fill="url(#paint2_linear)"
    />
    <path
      d="M2.77444 0.00141466C2.23576 -0.0146755 1.70187 0.106687 1.22308 0.35406C0.744292 0.601433 0.33639 0.966667 0.0378347 1.41533C-0.142325 1.69811 0.369647 1.94782 0.549806 1.66618C1.00591 0.948964 1.8782 0.494003 2.81891 0.517948C3.29436 0.53436 3.75842 0.667822 4.16994 0.906503C4.58147 1.14518 4.92775 1.48171 5.17809 1.88625C5.35825 2.18385 5.83145 1.91362 5.65129 1.61829C5.07775 0.671883 3.95574 0.0276404 2.77444 0.00141466Z"
      transform="translate(79.928 5.165)"
      fill="url(#paint3_linear)"
    />
    <path
      d="M9.09004 1.62216C8.39339 0.897152 7.50426 0.386064 6.52715 0.148957C5.55005 -0.08815 4.52556 -0.0414234 3.57409 0.283643C2.62262 0.60871 1.78371 1.19861 1.15594 1.98402C0.528174 2.76943 0.137639 3.71771 0.0302289 4.71742C-0.0771817 5.71713 0.102997 6.72673 0.549591 7.62757C0.996186 8.52841 1.69064 9.28306 2.55134 9.80283C3.41203 10.3226 4.40321 10.5859 5.40839 10.5618C6.41356 10.5376 7.39096 10.2271 8.22573 9.66663L12.0433 13.6381C12.0667 13.6625 12.0947 13.6821 12.1256 13.6957C12.1566 13.7092 12.1899 13.7165 12.2237 13.7172C12.2575 13.7178 12.2911 13.7117 12.3226 13.6994C12.354 13.687 12.3827 13.6685 12.407 13.645L13.358 12.7328C13.3824 12.7094 13.402 12.6814 13.4155 12.6504C13.4291 12.6195 13.4364 12.5861 13.437 12.5523C13.4377 12.5185 13.4316 12.4849 13.4192 12.4535C13.4068 12.422 13.3884 12.3933 13.3648 12.369L9.54729 8.39753C10.2798 7.39465 10.6355 6.16571 10.5519 4.92662C10.4683 3.68752 9.95067 2.51752 9.09004 1.62216ZM7.90076 8.00756C7.36214 8.5253 6.68209 8.8717 5.94661 9.00297C5.21112 9.13424 4.45323 9.04447 3.76876 8.74503C3.08429 8.44558 2.50398 7.9499 2.10121 7.32066C1.69843 6.69142 1.49128 5.95688 1.50595 5.20992C1.52062 4.46296 1.75645 3.73711 2.18361 3.12417C2.61078 2.51123 3.2101 2.03872 3.9058 1.76637C4.6015 1.49403 5.36233 1.43408 6.0921 1.59412C6.82186 1.75416 7.48778 2.127 8.00567 2.66549C8.69993 3.38769 9.0789 4.35608 9.05923 5.35768C9.03956 6.35927 8.62285 7.31204 7.90076 8.00642V8.00756Z"
      transform="translate(77.257 2.468)"
      fill="#EF5753"
    />
    <path
      d="M0.318987 -6.26359e-07C-0.106326 -6.26359e-07 -0.106326 0.660206 0.318987 0.660206C0.744301 0.660206 0.744301 -6.26359e-07 0.318987 -6.26359e-07Z"
      transform="translate(79.422 6.7)"
      fill="#EF5753"
    />
    <path
      d="M2.77444 0.00141508C2.23576 -0.0146751 1.70187 0.106687 1.22308 0.35406C0.744292 0.601433 0.33639 0.966666 0.0378347 1.41533C-0.142325 1.69811 0.369647 1.94782 0.549806 1.66618C1.00591 0.948964 1.8782 0.494003 2.81891 0.517949C3.29436 0.53436 3.75842 0.667822 4.16994 0.906503C4.58147 1.14518 4.92775 1.48171 5.17809 1.88625C5.35825 2.18386 5.83145 1.91361 5.65129 1.61829C5.07775 0.671882 3.95574 0.0276409 2.77444 0.00141508Z"
      transform="translate(79.928 4.585)"
      fill="#EF5753"
    />
    <path
      d="M99.2748 0H0V38.4972H99.2748V0Z"
      transform="translate(0 24.445)"
      fill="url(#paint4_linear)"
    />
    <path
      d="M96.9247 0H0V36.3261H96.9247V0Z"
      transform="translate(1.16 25.384)"
      fill="#fff"
    />
    <path
      d="M8.14823 16.2965C12.6484 16.2965 16.2965 12.6484 16.2965 8.14823C16.2965 3.64809 12.6484 0 8.14823 0C3.64809 0 0 3.64809 0 8.14823C0 12.6484 3.64809 16.2965 8.14823 16.2965Z"
      transform="translate(5.66 35.315)"
      fill="#EF5753"
    />
    <path
      d="M33.9487 0H0V4.07411H33.9487V0Z"
      transform="translate(27.896 37.013)"
      fill="#BDBDBD"
    />
    <path
      d="M33.9487 0H0V4.07411H33.9487V0Z"
      transform="translate(27.896 45.33)"
      fill="#E0E0E0"
    />
    <path
      d="M32.0821 0H3.0622e-06V36.3261H32.0821V0Z"
      transform="translate(66.173 25.384)"
      fill="#EF5753"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-90 29.451 -11.067) scale(18.3843)"
      >
        <stop stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-90 6.79 6.924) scale(13.7161)"
      >
        <stop stopColor="#B3B3B3" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="#B3B3B3" stopOpacity="0.1" />
        <stop offset="1" stopColor="#B3B3B3" stopOpacity="0.05" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 -.6602 .6602 0 -.011 .66)"
      >
        <stop stopOpacity="0.12" />
        <stop offset="0.55" stopOpacity="0.09" />
        <stop offset="1" stopOpacity="0.02" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 -35.6742 100.74 0 5000.38 477.672)"
      >
        <stop stopOpacity="0.12" />
        <stop offset="0.55" stopOpacity="0.09" />
        <stop offset="1" stopOpacity="0.02" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 -12997 33516.2 0 26458.2 21250)"
      >
        <stop stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
    </defs>
  </svg>
);

export default FilterDraw;




// WEBPACK FOOTER //
// ./src/Icons/FilterDraw.js